// extracted by mini-css-extract-plugin
export default {"projects":"homepage_projects__ds-pP","heading":"homepage_heading__ECpFs"};